import React from "react";

const ChartWrapper = ({ children, height = "400px" }) => (
  <div className="relative w-full" style={{ height }}>
    {children}
  </div>
);


export default ChartWrapper;
